import React from "react";

// css
import "./PreFooter.css";

const PrePreFooter = (props) => {
  return (
    <section className="pre-footer pre-pre-footer-main">
      <div>
        <div className="main-margin prefooter-content">
          <h1 className="my-6 uppercase text-2xl">footnotes</h1>
          {props.children}
          </div>
      </div>
    </section>
  );
};

export default PrePreFooter;
